<h2 class="fw-bold f-size-24 mb-3 f-color-dark">საბანკო რეკვიზიტები</h2>
<div class="d-flex">
  <div
    class="bank-details__info d-flex justify-content-center align-items-center mr-2"
  >
    <img src="/assets/images/info.svg" alt="info" />
  </div>
  <p class="f-size-14 f-color-actions-text">
    საბანკო რეკვიზიტები საჭიროა, რომ დაიბრუნოთ საგარანტიო თანხა თქვენს ანგარიშზე
    იმ შემთხვევაში თუ მიიღებთ მონაწილეობას აუქციონში და ვერ გაიმარჯვებთ.
  </p>
</div>
<button class="btn btn-primary p-3 mt-4 fw-medium f-size-14 bg-vibrant-blue">
  დაამატე საბანკო რეკვიზიტი
</button>
